export const PATH_ROOT = '/';
export const PATH_SIGN_IN = '/sign-in';
export const PATH_SIGN_UP = '/sign-up';
//
export const PATH_ORDERS = '/orders';
export const PATH_ORDERS_ARCHIVE = '/orders-archive';
export const PATH_ORDER_NEW = '/order-new';
export const PATH_ORDER_EDIT = '/order-edit/:orderId';
//
export const PATH_STOCK = '/stock';
export const PATH_STOCK_PALLET = '/pallet-stock';
